import { hardNavigate } from '@/utils';

const RELOAD_GUARD_KEY = 'chunkLoadReloadAt';
const RELOAD_GUARD_MS = 10_000;

// webpack's error when a lazily loaded route chunk (js or css) cannot be fetched
export const isChunkLoadError = (error: unknown): boolean =>
  error instanceof Error &&
  (error.name === 'ChunkLoadError' || /Loading (CSS )?chunk [\w-]+ failed/.test(error.message));

// A tab opened before a deploy still references the previous build's hashed chunks,
// which no longer exist on the server. A full page load to the intended route fetches
// the current build. Guarded so a chunk that is missing in the new build too cannot
// cause a reload loop.
export const reloadForNewBuild = (href: string): boolean => {
  try {
    const lastReloadAt = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0);
    if (Date.now() - lastReloadAt < RELOAD_GUARD_MS) return false;
    sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  } catch {
    // sessionStorage unavailable: reload anyway
  }
  hardNavigate(href);
  return true;
};
